// extracted by mini-css-extract-plugin
export default {"folderName":"FolderNames_folderName__k1aol","folderNamesList":"FolderNames_folderNamesList__TkRA+"};